import { DEFAULT_STICKY_COLOR, DEFAULT_NODE_COLOR } from '../../../utils/constants';
import type { StickyData } from './types';

export function makeDefault(): StickyData {
  return {
    text: '',
    fill: DEFAULT_STICKY_COLOR,
    fillOpacity: 1,
    stroke: 'none',
    strokeOpacity: 1,
    textAlign: 'left',
    verticalAlign: 'middle',
    fontSize: 14,
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
    textColor: DEFAULT_NODE_COLOR,
  };
}
